<script setup lang="ts">
import { useUserStore } from '@/store/modules/user'
import { useNotifications } from '@/utils/composables/useNotifications'
import { ua } from '@/utils/ua'
import { useI18n } from 'vue-i18n'
import { VxeUI } from 'vxe-table'
import Provider from './ui/provider/index.vue'

const route = useRoute()

const settingsStore = useSettingsStore()
const { auth } = useAuth()

document.body.setAttribute('data-os', ua.getOS().name || '')

const isAuth = computed(() => {
  return route.matched.every((item) => {
    return auth(item.meta.auth ?? '')
  })
})

// 设置vxe-table的全局配置
VxeUI.setConfig({
  zIndex: 11999,
})

// 设置网页 title
const { t } = useI18n()

watch([
  () => settingsStore.settings.app.enableDynamicTitle,
  () => settingsStore.title,
], () => {
  if (settingsStore.settings.app.enableDynamicTitle && settingsStore.title) {
    const title = typeof settingsStore.title === 'function' ? settingsStore.title() : settingsStore.title
    const translatedTitle = title.startsWith('app.') || title.startsWith('toolbar.') ? t(title) : title
    document.title = `${translatedTitle} - ${t('app.title')}`
  }
  else {
    document.title = t('app.title')
  }
}, {
  immediate: true,
  deep: true,
})

// 监听 Fantastic-admin 的颜色方案变化
watch(() => settingsStore.settings.app.colorScheme, (val) => {
  if (val === 'dark') {
    VxeUI.setTheme('dark')
  }
  else {
    VxeUI.setTheme('light')
  }
}, { immediate: true })
const userStore = useUserStore()
const { user_id } = storeToRefs(userStore)

const { startNotificationListener, stopNotificationListener } = useNotifications()

watch(
  () => user_id.value,
  (newUserId, oldUserId) => {
    if (oldUserId) {
      stopNotificationListener()
    }

    if (!newUserId) {
      return
    }

    startNotificationListener(newUserId)
  },
  { immediate: true },
)

onMounted(() => {
  settingsStore.setMode(document.documentElement.clientWidth)
  window.addEventListener('resize', () => {
    settingsStore.setMode(document.documentElement.clientWidth)
  })
})

onBeforeUnmount(() => {
  stopNotificationListener()
})
</script>

<template>
  <Provider>
    <RouterView v-slot="{ Component }">
      <component :is="Component" v-if="isAuth" />
      <FaNotAllowed v-else />
    </RouterView>
    <FaBackToTop />
    <FaToast />
    <FaNotification />
    <FaSystemInfo />
  </Provider>
</template>
